<header *ngIf="showHeader" class="header-hld header-invison">
  <section class="header-bot">
    <div class="container">
      <div class="row">
        <div class="col-9 ">
          <a href="javascript:void(0)" title="Sanlam" class="logo-hld">
            <app-logo size="large"  width="203" height="44" viewBox="0 0 203 44" fill="none"></app-logo>
          </a>
        </div>

      </div>
    </div>
  </section>
</header>
<div class="container">
  <div class=" mt-5 py-3 text-center alert alert-success">
    <p class="m-0">{{displayText}}</p>
  </div>

</div>